import { createRootRoute, Outlet } from "@tanstack/react-router";
import { useThemeAttributes } from "@/hooks/useThemeAttributes";

export const Route = createRootRoute({ component: RootLayout });

function RootLayout() {
  useThemeAttributes();

  return <Outlet />;
}
